<template>
  <span :class="['rounded-full px-3 py-1 text-xs font-medium', typeClass]">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    type: { type: String, default: 'success' }
  },
  computed: {
    typeClass() {
      if (this.type === 'danger') return 'bg-red-100 text-red-600'
      if (this.type === 'default') return 'bg-gray-100 text-gray-700'
      return 'bg-green-100 text-green-700'
    }
  }
}
</script>

<style scoped></style>